import React, { useEffect } from "react";
import { Alert, Box, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import { useOrganisations } from "services/hooks/rentals";

const AccountingOrgBar = ({
	requiresOrganizationSelection,
	organizationId,
	onOrganizationChange,
	sessionOrganization,
}) => {
	if (!requiresOrganizationSelection) {
		if (!sessionOrganization) {
			return (
				<Alert severity="warning" sx={{ flex: 1 }}>
					No organisation linked to this manager account.
				</Alert>
			);
		}
		return (
			<Box>
				<Typography variant="body2" color="text.secondary">
					Organisation:{" "}
					<strong>{sessionOrganization.name}</strong>
					{sessionOrganization.code ? ` (${sessionOrganization.code})` : ""}
				</Typography>
			</Box>
		);
	}

	return (
		<AdminOrganizationSelect value={organizationId} onChange={onOrganizationChange} />
	);
};

const AdminOrganizationSelect = ({ value, onChange }) => {
	const { organisations, isLoadingOrganisations } = useOrganisations({ enabled: true });
	const list = Array.isArray(organisations) ? organisations : [];

	useEffect(() => {
		if (!value && list.length > 0) {
			onChange(list[0].id);
		}
	}, [list, value, onChange]);

	return (
		<FormControl size="small" sx={{ minWidth: 220 }} disabled={isLoadingOrganisations}>
			<InputLabel>Organisation</InputLabel>
			<Select label="Organisation" value={value ?? ""} onChange={(e) => onChange(e.target.value)}>
				{list.map((org) => (
					<MenuItem key={org.id} value={org.id}>
						{org.name}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default AccountingOrgBar;
